import dayjs, { Dayjs } from 'dayjs';

export const commonDateTimePickerSx = {
  '& .MuiInputBase-root': {
    height: '48.3px'
  },
  '.MuiFormHelperText-root': {
    marginLeft: 0
  }
};

export const getDateFieldValue = (
  formValues: Record<string, unknown>,
  fieldName: string
): Dayjs | null => {
  const rawValue = formValues[fieldName] as string | null | undefined;
  return rawValue ? dayjs(rawValue) : null;
};

export const buildDateChangeHandler =
  (
    fieldName: string,
    setFieldTouched: (field: string, isTouched?: boolean) => void,
    setFieldValue: (field: string, value: string | null) => void
  ) =>
  (newValue: Dayjs | null) => {
    setFieldTouched(fieldName, true);
    setFieldValue(fieldName, newValue ? newValue.toISOString() : null);
  };

export const buildTextFieldSlotProps = (
  label: string,
  fieldName: string,
  errors: Record<string, unknown>,
  touched: Record<string, boolean>,
  edit: boolean
) => ({
  textField: {
    label,
    error: Boolean(errors[fieldName]) && Boolean(touched[fieldName]),
    helperText:
      edit || Boolean(touched[fieldName])
        ? (errors[fieldName] as any)?.toString?.() || ''
        : ''
  }
});
